// src/components/home/HomeDoctor.jsx

import React from "react";
import { Link } from "react-router-dom";

import portrait from "../../assets/images/portrait.jpg";

import "./css/HomeDoctor.css";

const HomeDoctor = () => {
  return (
    <section className="home-doctor">

      <div className="home-container doctor-grid">

        <div className="doctor-image-wrap">

          <div className="doctor-image-frame">

            <img
              src={portrait}
              alt="Dr. Vaishnavi K M"
            />

            <div className="doctor-image-label">
              Founder &amp; Chief Ayurvedic Consultant
            </div>

          </div>

        </div>


        <div className="doctor-content">

          <span className="home-section-eyebrow">
            MEET THE DOCTOR
          </span>

          <h2>
            Ayurveda with
            <br />
            knowledge, care &amp; purpose.
          </h2>

          <p className="doctor-qualification">
            BAMS, MD (Ayurveda) · Rasashastra &amp;
            Bhaishajya Kalpana
          </p>

          <div className="home-divider"></div>

          <p>
            Dr. Vaishnavi K M is an Ayurvedic physician and the
            founder of Sudhamshu Ayurveda, Bengaluru. With over
            six years of clinical and research experience, she
            brings together classical Ayurvedic wisdom and
            scientific thinking in her approach to patient care.
          </p>

          <p>
            Her practice focuses on understanding the individual
            behind the condition and creating a thoughtful,
            personalized path towards better health.
          </p>


          <div className="doctor-stat-row">

            <div>
              <strong>500+</strong>
              <span>Patients</span>
            </div>

            <div>
              <strong>8</strong>
              <span>Research Articles</span>
            </div>

            <div>
              <strong>80+</strong>
              <span>Academic Events</span>
            </div>

          </div>


          <Link
            to="/about"
            className="home-text-link"
          >
            Discover Dr. Vaishnavi's journey
            <span>→</span>
          </Link>

        </div>

      </div>

    </section>
  );
};

export default HomeDoctor;